import { GlobalEventNames } from '@inertiajs/core/types/types';
import { router } from '@inertiajs/react';
import { useEffect } from 'react';

import InertiaNavigationEvent from '../../types/inertia/InertiaNavigationEvent';

type InertiaEventHandler = (event: InertiaNavigationEvent) => void;

const useInertiaEvent = (
    eventType: GlobalEventNames,
    handler: InertiaEventHandler
) => {
    useEffect(
        () =>
            router.on(eventType, (event) => {
                // TODO: WTF typescript
                const typedEvent = event as unknown as InertiaNavigationEvent;

                handler(typedEvent);
            }),
        []
    );
};

export default useInertiaEvent;
